// SPDX-License-Identifier: MIT

// Core Web Vitals → dataLayer, matching gatsby-plugin-google-tagmanager's
// `enableWebVitalsTracking` (same `core-web-vitals` event + shape, so an existing
// GTM trigger keyed on it keeps working). Measuring sets no cookies and sends no
// requests; the metrics sit in dataLayer, and GTM — loaded only on consent —
// decides whether to forward them to GA. So this can run for every visitor.

// Pushes one metric in the legacy plugin's format (CLS is scaled ×1000).
const pushMetric = ({ name, id, value }) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'core-web-vitals',
    webVitalsMeasurement: {
      name,
      id,
      value: name === 'CLS' ? Math.round(value * 1000) : Math.round(value),
    },
  });
};

// Dynamically imports web-vitals so a missing/rebuilding dep never breaks the
// build, and supports both the v3+/v4 (onCLS…) and v2 (getCLS…) names.
const reportWebVitals = () => {
  if (typeof window === 'undefined') return;
  import('web-vitals')
    .then((v) => {
      const bind = [
        v.onCLS || v.getCLS,
        v.onLCP || v.getLCP,
        v.onINP || v.onFID || v.getFID,
        v.onFCP || v.getFCP,
        v.onTTFB || v.getTTFB,
      ];
      bind.forEach((fn) => {
        if (typeof fn === 'function') fn(pushMetric);
      });
    })
    .catch(() => {
      /* web-vitals unavailable: skip quietly */
    });
};

module.exports = { reportWebVitals, pushMetric };
